import { Title, Text, ActionIcon, Button, Popover } from "rizzui";
import TrashIcon from "@/components/icons/trash";
import { PiTrashFill } from "react-icons/pi";
import cn from "@/utils/class-names";

type DeletePopoverProps = {
  title: string;
  description: React.ReactNode;
  disabled?: boolean;
  iconButtonClass?: string;
  isDeleting?: boolean;
  icon?: React.ReactNode;
  iconVariant?: "outline" | "solid" | "text" | "flat" | undefined;
  iconClass?: string;
  onDelete: () => void;
  children?: React.ReactElement;
  noAction?: boolean;
};

export default function DeletePopover({
  title,
  description,
  onDelete,
  disabled,
  iconButtonClass = "",
  isDeleting,
  icon,
  iconVariant = "outline",
  iconClass,
  children,
  noAction,
}: DeletePopoverProps) {
  return (
    <Popover placement="left">
      <Popover.Trigger>
        {children ? (
          children
        ) : (
          <ActionIcon
            size="sm"
            variant={iconVariant}
            aria-label={"Delete Item"}
            disabled={disabled}
            className={cn(
              "cursor-pointer hover:!border-gray-900 hover:text-gray-700",
              disabled && "cursor-not-allowed pointer-events-none",
              iconButtonClass,
            )}
          >
            {icon ? icon : <TrashIcon className={cn("h-4 w-4", iconClass)} />}
          </ActionIcon>
        )}
      </Popover.Trigger>
      <Popover.Content className="z-50">
        {({ setOpen }) => (
          <div className="w-56 pb-2 pt-1 text-left rtl:text-right">
            <Title
              as="h6"
              className="mb-2 flex items-start text-sm text-gray-700 sm:items-center"
            >
              <PiTrashFill className="me-1 h-[17px] w-[17px]" /> {title}
            </Title>
            <Text className="mb-2 leading-relaxed text-gray-500">
              {description}
            </Text>
            <div className="flex items-center justify-end">
              {noAction ? (
                <Button
                  size="sm"
                  variant="outline"
                  className="h-7"
                  onClick={() => setOpen(false)}
                >
                  Close
                </Button>
              ) : (
                <>
                  <Button
                    size="sm"
                    className="me-1.5 h-7"
                    isLoading={isDeleting}
                    onClick={() => {
                      onDelete();
                      setOpen(false);
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    size="sm"
                    variant="outline"
                    className="h-7"
                    onClick={() => setOpen(false)}
                    isLoading={isDeleting}
                  >
                    No
                  </Button>
                </>
              )}
            </div>
          </div>
        )}
      </Popover.Content>
    </Popover>
  );
}
